// Performance monitoring utilities
export const performanceMonitor = {
  // Track page load time
  trackPageLoad: () => {
    if (typeof window !== 'undefined' && window.performance) {
      window.addEventListener('load', () => {
        const loadTime = window.performance.timing.loadEventEnd - window.performance.timing.navigationStart;
        console.log(`📊 Page load time: ${loadTime}ms`);
        
        // Warn if load time is too long
        if (loadTime > 5000) {
          console.warn('⚠️ Slow page load detected:', loadTime + 'ms');
        }
      });
    }
  },

  // Track WebSocket connection time
  trackWebSocketConnection: (serviceName, startTime) => {
    const connectionTime = Date.now() - startTime;
    console.log(`📊 ${serviceName} WebSocket connection time: ${connectionTime}ms`);
    
    if (connectionTime > 3000) {
      console.warn(`⚠️ Slow ${serviceName} WebSocket connection: ${connectionTime}ms`);
    }
  },

  // Track memory usage
  trackMemoryUsage: () => {
    if (typeof window !== 'undefined' && window.performance && window.performance.memory) {
      const memory = window.performance.memory;
      const usedMB = Math.round(memory.usedJSHeapSize / 1048576);
      const totalMB = Math.round(memory.totalJSHeapSize / 1048576);
      
      console.log(`📊 Memory usage: ${usedMB}MB / ${totalMB}MB`);
      
      if (usedMB > 100) {
        console.warn('⚠️ High memory usage detected:', usedMB + 'MB');
      }
    }
  },

  // Track render performance
  trackRenderTime: (componentName, startTime) => {
    const renderTime = Date.now() - startTime;
    console.log(`📊 ${componentName} render time: ${renderTime}ms`);
    
    if (renderTime > 100) {
      console.warn(`⚠️ Slow ${componentName} render: ${renderTime}ms`);
    }
  },

  // Get browser performance metrics
  getPerformanceMetrics: () => {
    if (typeof window === 'undefined' || !window.performance) {
      return null;
    }

    const timing = window.performance.timing;
    const navigation = window.performance.navigation;
    
    return {
      // Page load metrics
      domContentLoaded: timing.domContentLoadedEventEnd - timing.navigationStart,
      loadComplete: timing.loadEventEnd - timing.navigationStart,
      
      // Network metrics
      dnsLookup: timing.domainLookupEnd - timing.domainLookupStart,
      tcpConnection: timing.connectEnd - timing.connectStart,
      requestResponse: timing.responseEnd - timing.requestStart,
      
      // Navigation type
      navigationType: navigation.type,
      
      // Memory usage
      memory: window.performance.memory ? {
        used: Math.round(window.performance.memory.usedJSHeapSize / 1048576),
        total: Math.round(window.performance.memory.totalJSHeapSize / 1048576),
        limit: Math.round(window.performance.memory.jsHeapSizeLimit / 1048576)
      } : null
    };
  },

  // Log performance report
  logPerformanceReport: () => {
    const metrics = performanceMonitor.getPerformanceMetrics();
    if (metrics) {
      console.group('📊 Performance Report');
      console.log('Page Load Time:', metrics.loadComplete + 'ms');
      console.log('DOM Ready Time:', metrics.domContentLoaded + 'ms');
      console.log('DNS Lookup Time:', metrics.dnsLookup + 'ms');
      console.log('TCP Connection Time:', metrics.tcpConnection + 'ms');
      console.log('Request/Response Time:', metrics.requestResponse + 'ms');
      
      if (metrics.memory) {
        console.log('Memory Usage:', `${metrics.memory.used}MB / ${metrics.memory.total}MB (${metrics.memory.limit}MB limit)`);
      }
      
      console.groupEnd();
    }
  }
};

// Initialize performance monitoring
if (typeof window !== 'undefined') {
  performanceMonitor.trackPageLoad();
  
  // Log performance report after 3 seconds
  setTimeout(() => {
    performanceMonitor.logPerformanceReport();
  }, 3000);
}
